/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMcpServerForm,
  UpdateMcpServerForm$Outbound,
  UpdateMcpServerForm$outboundSchema,
} from "../components/updatemcpserverform.js";

export type UpdateMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateMcpServerSecurity = {
  option1?: UpdateMcpServerSecurityOption1 | undefined;
  option2?: UpdateMcpServerSecurityOption2 | undefined;
};

export type UpdateMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateMcpServerForm: UpdateMcpServerForm;
};

/** @internal */
export type UpdateMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateMcpServerSecurityOption1$Outbound,
  UpdateMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMcpServerSecurityOption1ToJSON(
  updateMcpServerSecurityOption1: UpdateMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateMcpServerSecurityOption1$outboundSchema.parse(
      updateMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateMcpServerSecurityOption2$Outbound,
  UpdateMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateMcpServerSecurityOption2ToJSON(
  updateMcpServerSecurityOption2: UpdateMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateMcpServerSecurityOption2$outboundSchema.parse(
      updateMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateMcpServerSecurity$Outbound = {
  Option1?: UpdateMcpServerSecurityOption1$Outbound | undefined;
  Option2?: UpdateMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UpdateMcpServerSecurity$Outbound,
  UpdateMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateMcpServerSecurityToJSON(
  updateMcpServerSecurity: UpdateMcpServerSecurity,
): string {
  return JSON.stringify(
    UpdateMcpServerSecurity$outboundSchema.parse(updateMcpServerSecurity),
  );
}

/** @internal */
export type UpdateMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateMcpServerForm: UpdateMcpServerForm$Outbound;
};

/** @internal */
export const UpdateMcpServerRequest$outboundSchema: z.ZodMiniType<
  UpdateMcpServerRequest$Outbound,
  UpdateMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateMcpServerForm: UpdateMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateMcpServerForm: "UpdateMcpServerForm",
    });
  }),
);

export function updateMcpServerRequestToJSON(
  updateMcpServerRequest: UpdateMcpServerRequest,
): string {
  return JSON.stringify(
    UpdateMcpServerRequest$outboundSchema.parse(updateMcpServerRequest),
  );
}
